import React from 'react';
import { Link } from 'react-router-dom';
const HomeTuition = () => {
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-br from-yellow-100 via-green-50 to-blue-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition duration-300">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 flex justify-center items-center p-4">
          <img
            src="https://plus.unsplash.com/premium_photo-1663013506908-a6f66c941587?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fHN0dWR5fGVufDB8fDB8fHww"
            alt="Home Tuition"
            className="w-full max-w-sm h-auto rounded-lg object-cover shadow-md"
          />
        </div>
        <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
            📚 Subject Teachers (All Grades)
          </h1>
          <p className="text-base text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
            We offer experienced and qualified home tutors and online subject teachers for all school levels – from foundational to advanced grades (Nursery to Class 12).
          </p>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-4">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">🔹 Subjects Offered:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>📖 English | Hindi | Sanskrit</li>
              <li>➗ Mathematics (Basic to Advanced)</li>
              <li>🔬 Science (Physics, Chemistry, Biology)</li>
              <li>🌍 Social Science (History, Geography, Civics, Economics)</li>
              <li>💼 Commerce (Accounts, Business Studies, Economics)</li>
              <li>💻 Computer Science / IT</li>
            </ul>
          </div>
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-6">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">👨‍🏫 Teacher Profiles:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>🎓 Verified academic background</li>
              <li>📘 Specialized in CBSE, ICSE, IB, State Boards</li>
              <li>📊 Regular assessments & performance feedback</li>
            </ul>
          </div>
          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto">
                Book a Free Demo Class
              </button>
            </Link>
            <a
              href="https://wa.me/919999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto text-center"
            >
              📲 Connect on WhatsApp
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeTuition;
